import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import styled from "styled-components";
import moment from "moment";
import CouponCard from "./CouponCard";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const PromoSwiper = styled.div`
  width: 100%;
  .swiper {
    overflow: hidden;
  }
  .swiper-pagination {
    position: static;
    margin-top: 10px;
    text-align: center;
  }
  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: #cdd2d7;
    opacity: 1;
    margin: 0 6px !important;
  }
  .swiper-pagination-bullet-active {
    background: #f3c821;
  }
  ${(props) =>
    props.$isCode &&
    `
    .swiper-slide { width: auto !important; }
  `}
`;

const Slide = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 175px;
  max-height: 175px;
  overflow: hidden;
  border-radius: 14px;
  position: relative;
`;

const SlideImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 14px;
`;

const Caption = styled.div`
  position: absolute;
  left: 12px;
  bottom: 12px;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  font-size: 14px;
`;

// Helper function to format expire date
const formatExpireDate = (dateString) => {
  if (!dateString) return "ไม่ระบุวันหมดอายุ";

  try {
    const formattedDate = moment(dateString).format("DD/MM/YYYY");
    return `หมดอายุ ${formattedDate}`;
  } catch (error) {
    console.error("Error formatting date:", error);
    return "ไม่ระบุวันหมดอายุ";
  }
};

function renderSlideContent(slide, cardType, index) {
  if (!slide) return null;

  switch (cardType) {
    case "highlight":
      return (
        <Slide>
          <SlideImage
            src={slide.imageFileUrl || ""}
            alt={slide.name || `slide-${index + 1}`}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
          {/* {slide.title && <Caption>{slide.title}</Caption>} */}
        </Slide>
      );
    case "code":
    default:
      return (
        <div style={{ padding: "4px", width: "auto" }}>
          <CouponCard image={slide.imageFileUrl || ""} title={slide.couponName || "ไม่ระบุชื่อ"} pointsText={slide.cashAmount ? `${slide.cashAmount} บาท` : "0 บาท"} expireText={formatExpireDate(slide.expireDtm)} />
        </div>
      );
  }
}

const SwiperComponent = ({ slides = [], type = "highlight" }) => {
  // Guard against invalid slides data
  if (!Array.isArray(slides) || slides.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        <p>ไม่มีข้อมูลที่จะแสดง</p>
      </div>
    );
  }

  const isCode = type === "code";

  return (
    <PromoSwiper $isCode={isCode}>
      <Swiper
        spaceBetween={5}
        slidesPerView={isCode ? "auto" : 1}
        pagination={{ clickable: true }}
        navigation={false}
        modules={[Pagination, Navigation, Autoplay]}
        autoplay={{
          delay: 2500,
        }}
        loop={slides.length > 1}
        autoHeight
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={`${type}-${index}`}>{renderSlideContent(slide, type, index)}</SwiperSlide>
        ))}
      </Swiper>
    </PromoSwiper>
  );
};

export default SwiperComponent;
